import validate from "validate.js";
export const isEmpty = (value) => {
    return validate.isEmpty(value);
};
